var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function GlobalURL(create) {
    return function (params) {
        var _a = __read(create(params).split("?"), 2), _b = _a[0], path = _b === void 0 ? "" : _b, _c = _a[1], query = _c === void 0 ? "" : _c;
        var queryParams = query.split(/&/g);
        if (params.campaign) {
            //queryParams.push(`campaign=${encodeURIComponent(params.campaign)}`);
        }
        var url = path;
        if (queryParams.length) {
            url += "?".concat(queryParams.toString().replace(/,/g, "&"));
        }
        return url;
    };
}
